<div class="wrapper--spacing-horizontal page-content">
  <div class="monitoring-header">
    <h1 class="text--h1">
      {{
        (isIndividualMonitoring()
          ? 'height-measurement.monitoring.individual-title'
          : 'height-measurement.monitoring.title'
        ) | translate
      }}
    </h1>
    <div class="monitoring-actions">
      @if (isIndividualMonitoring()) {
        <button mat-raised-button color="primary" (click)="navigateToCompanyMonitoring()">
          {{ 'height-measurement.monitoring.buttons.back-to-company-monitoring' | translate }}
        </button>
      } @else {
        <button
          mat-raised-button
          color="primary"
          (click)="printCompanyReport()"
          class="print-button"
        >
          <mat-icon>print</mat-icon>
          {{ 'height-measurement.monitoring.print.print-button' | translate }}
        </button>
      }
    </div>
  </div>

  @if (!isIndividualMonitoring()) {
    <div class="date-selector">
      <p class="selection-info">
        {{ 'height-measurement.monitoring.selection-limit' | translate }}:
        {{ selectedDates().length }} / {{ maxSelections }}
      </p>
      <div class="date-checkboxes">
        @for (date of availableDates(); track date) {
          <mat-checkbox
            [checked]="isDateSelected(date)"
            [disabled]="!isDateSelected(date) && !canSelectMore()"
            [color]="isDateSelected(date) ? 'primary' : ''"
            (change)="toggleDate(date)"
          >
            <span class="date-label">
              @if (isDateSelected(date)) {
                <span class="color-indicator" [style.background-color]="getDateColor(date)"></span>
              }
              {{ date | date: 'dd/MM/yyyy' }}
            </span>
          </mat-checkbox>
        }
      </div>
    </div>
  }

  <highcharts-chart
    class="chart-container"
    [update]="true"
    [options]="chartOptions()"
    (chartInstance)="setupChartInstance($event)"
  />

  <company-report-print
    [chartImageUrl]="chartImageForPrint"
    [printTableData]="printTableData"
    [reportDate]="reportDateForPrint"
    [alvaMetrics]="alvaMetricsForPrint"
    [selectedDates]="selectedDatesForPrint"
    [location]="locationForPrint"
    [stallListCowMeasurements]="stallListCowMeasurementsForPrint"
    [stallListDate]="stallListDateForPrint"
  />
</div>
